export default __webpack_public_path__ + "static/media/imgAutoinmunes.61216f24.png";